import { render, staticRenderFns } from "./email.vue?vue&type=template&id=0a4e8451&scoped=true&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e8451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4e8451')) {
      api.createRecord('0a4e8451', component.options)
    } else {
      api.reload('0a4e8451', component.options)
    }
    module.hot.accept("./email.vue?vue&type=template&id=0a4e8451&scoped=true&", function () {
      api.rerender('0a4e8451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/input/email.vue"
export default component.exports